<script setup>
defineProps({
  payment: {
    type: Object,
    required: true,
  },
});

defineEmits(["print"]);

const formatCurrency = (value) => {
  return new Intl.NumberFormat("th-TH", {
    style: "currency",
    currency: "THB",
    minimumFractionDigits: 0,
  }).format(value || 0);
};

const methodText = (method) => {
  const map = {
    cash: "เงินสด",
    bank_transfer: "โอนธนาคาร",
    qr_payment: "QR Payment",
    credit_card: "บัตรเครดิต",
  };
  return map[method] || method;
};
</script>

<template>
  <div class="card border-0 shadow-sm rounded-4 h-100">
    <div class="card-body p-4">
      <div class="d-flex align-items-center justify-content-between mb-4">
        <div>
          <h5 class="fw-bold mb-1">สรุปการชำระ</h5>
          <div class="text-muted small">
            ช่องทางชำระ จำนวนเงิน ใบเสร็จ และข้อมูลอ้างอิง
          </div>
        </div>
        <div class="icon-box bg-success-subtle text-success">
          <i class="bi bi-receipt"></i>
        </div>
      </div>

      <div class="summary-box bg-light rounded-4 p-3 mb-3">
        <div class="text-muted small mb-1">จำนวนเงินที่รับชำระ</div>
        <div class="fw-bold fs-4 text-success">
          {{ formatCurrency(payment.amount) }}
        </div>
      </div>

      <div class="vstack gap-3 mb-4">
        <div class="d-flex align-items-center justify-content-between">
          <span class="text-muted">ช่องทางชำระ</span>
          <span class="fw-semibold">{{ methodText(payment.method) }}</span>
        </div>
        <div class="d-flex align-items-center justify-content-between">
          <span class="text-muted">เลขที่ใบเสร็จ</span>
          <span class="fw-semibold">{{ payment.receiptNo || "-" }}</span>
        </div>
        <div class="d-flex align-items-center justify-content-between">
          <span class="text-muted">ธนาคาร/ระบบอ้างอิง</span>
          <span class="fw-semibold">{{ payment.bankName || "-" }}</span>
        </div>
        <div class="d-flex align-items-center justify-content-between">
          <span class="text-muted">Reference No.</span>
          <span class="fw-semibold">{{ payment.referenceNo || "-" }}</span>
        </div>
      </div>

      <button
        type="button"
        class="btn btn-primary w-100 rounded-3"
        @click="$emit('print')"
      >
        <i class="bi bi-printer me-1"></i>พิมพ์ใบเสร็จ
      </button>
    </div>
  </div>
</template>

<style scoped>
.icon-box {
  width: 52px;
  height: 52px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.15rem;
}
</style>
